const SpinnerSize = {
	MINI: "mini",
	SMALL: "sml",
	NORMAL: ""
};
export default SpinnerSize;
